import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'peerConnectionStatus'
})
export class PeerConnectionStatusPipe implements PipeTransform {

  transform(value: unknown, row: any): unknown {

    switch (value) {
      case 'NOT_OK':
        return `<div class="center-content" title="${row.operState.toLowerCase() === 'predeleted' ? 'Pre-deleted' : 'Unavailable'}"><i class="fa fa-times-circle"></i></div>`;
      case 'OK':
        return '<div class="center-content" title="Available"><i class="fa fa-check-circle"></i></div>';
      case 'LOCKED':
        return '<div class="center-content" title="Locked"><i class="fa fa fa-lock"></i></div>';
      case 'LOCKED_INCOMING':
        return '<div class="space-between" title="Locked for incoming"><i class="fa fa-arrow-right"></i><i class="fa fa-lock"></i></div>';
      case 'LOCKED_OUTGOING':
        return '<div class="space-between" title="Locked for outgoing"><i class="fa fa-arrow-left"></i><i class="fa fa-lock"></i></div>';
      default:
        return '<div class="center-content" title="Unavailable"><i class="fa fa-times-circle"></i></div>';
    }
  }
}
